import axios from 'axios';
import { LANG_CODE_JAPANESE } from './constants';

const http = (state, statusAuthorization = true, type = 'applicant') => {
  let tokenData = null;

  const $http = axios.create({
    baseURL: state.baseUrl
  });

  $http.defaults.headers.post['Content-Type'] = 'application/json';

  const { contract_id, event_code } = state;

  if (contract_id && event_code) {
    const key = contract_id + event_code;

    const objFromLS =
      localStorage.getItem(key) !== null
        ? JSON.parse(localStorage.getItem(key))
        : null;

    if (statusAuthorization === true) {
      if (type == 'applicant') {
        const { token = '' } = objFromLS;
        tokenData = token;
      } else if (type == 'reception') {
        const { token_rc = '' } = objFromLS;
        tokenData = token_rc;
      } else {
        tokenData;
      }

      if (tokenData) {
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + tokenData;
      }
    }
  }

  return $http;
};

const validateDate = (value, lang) => {
  let dateformat;
  if (lang === LANG_CODE_JAPANESE) {
    dateformat = /\d{4}\/(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])*/; // YYYY/MM/DD
  } else {
    dateformat = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/; // DD / MM / YYYY;
  }

  if (value.match(dateformat)) {
    const opera1 = value.split('/');

    const lopera1 = opera1.length;
    let pdate;
    if (lopera1 > 1) {
      pdate = value.split('/');
    }

    let dd;
    let mm;
    let yy;

    if (lang === LANG_CODE_JAPANESE) {
      // YYYY/MM/DD
      yy = parseInt(pdate[0]);
      mm = parseInt(pdate[1]);
      dd = parseInt(pdate[2]);
    } else {
      // DD/MM/YYYY
      dd = parseInt(pdate[0]);
      mm = parseInt(pdate[1]);
      yy = parseInt(pdate[2]);
    }

    // Create list of days of a month [assume there is no leap year by default]
    //          month:  01,02,03,04,05,06,07,08,09,10,11,12
    const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (mm == 1 || mm > 2) {
      if (dd > ListofDays[mm - 1]) {
        return false;
      }
    }

    if (mm == 2) {
      let lyear = false;
      if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
        lyear = true;
      }
      if (lyear == false && dd >= 29) {
        return false;
      }
      if (lyear == true && dd > 29) {
        return false;
      }
    }
  } else {
    return false;
  }

  return true;
};

export { http, validateDate };
